// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "f5f9a2a";
